import { ReactElement } from 'react'
import { useParams } from 'react-router-dom'
import { useConfigStore } from '@stores'
import useHasAiPermission from 'src/hooks/useHasAiPermission'
import AIChatSession from './components/AIChatSession'
import DisabledChatButton from './components/DisabledChatButton'

/**
 * The navbar entry of the in-app AI chat (plan/ai-chat-architecture.md §7):
 * a button next to KI-Zugriff that opens the chat in the page's right drawer.
 * Shown to users with the KI permission only; disabled outside a project or
 * when this environment has no Copilot runtime configured.
 */
const AIChatWidget = (): ReactElement | null => {
  const { hasAiPermission } = useHasAiPermission()
  const copilotRuntimeUrl = useConfigStore(state => state.copilotRuntimeUrl)
  const { projectId }: { projectId?: string } = useParams()

  if (!hasAiPermission) return null
  if (!copilotRuntimeUrl) {
    return <DisabledChatButton reason="KI-Chat ist in dieser Umgebung nicht konfiguriert" />
  }
  if (!projectId) {
    return <DisabledChatButton reason="KI-Chat: bitte zuerst ein Projekt öffnen" />
  }

  // Keyed by project: a provider, thread and agent registration per project.
  return <AIChatSession key={projectId} projectId={projectId} />
}

export default AIChatWidget
